import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@material-ui/core";
import React from "react";
import { IoMdCloseCircleOutline } from "react-icons/io";
import OpenPdfDialog from "./OpenPdfDialog";

function GuidelineFile({openGuideline, guidelineHeader, openSignatureDialog, clickOnClose, pdfUrl, pdfHeader, height, agreeText, className}) {
  return (
    <>
        <Dialog
            style={{ width: "100%" }}
            open={openGuideline}
            aria-labelledby={"responsive-dialog-title"}
            maxWidth={"xl"}
            className={className}
        >
            <AppBar
            style={{ position: "sticky", backgroundColor: "#064473" }}
            >
            <Toolbar>
                <Typography
                    variant={"h6"}
                    style={{ marginLeft: "10px", flex: "1" }}
                >
                {guidelineHeader}
                </Typography>
                <IconButton
                    title={"Close"}
                    edge={"start"}
                    color={"inherit"}
                    onClick={clickOnClose}
                    aria-label={"close"}
                >
                <IoMdCloseCircleOutline />
                </IconButton>
            </Toolbar>
            </AppBar>
            <OpenPdfDialog
                openSignatureDialog={openSignatureDialog}
                pdfUrl={pdfUrl}
                pdfHeader={pdfHeader}
                height={height}
                agreeText={agreeText}
                className={className}
            />
        </Dialog>
    </>
  );
}

export default GuidelineFile;
